<template>
  <div data-mrf-recirculation="Listado de Noticias">
    <agency-card
      v-for="item in items"
      :key="item.id"
      :item="item"
    ></agency-card>
    <div class="title-section defaultSect" @click="getItems" v-show="enabled">
      <h3 class="heading-title-sect text-center">
        <span>Más Central de Agencias</span>
      </h3>
    </div>
  </div>
</template>

<script>
import AgencyCard from "./../agency-card/AgencyCard.vue";
import axios from "axios";
import epica from "../../../features/epica";

export default {
  components: { AgencyCard },
  props: {
    agencySlug: String,
    initOffset: Number,
    total: Number,
  },
  created: function () {
    this.take = this.initOffset;
    this.offset = 0;
    this.getItems();
  },
  updated: function () {
    epica();
    document.dispatchEvent(lrLoad);
  },
  methods: {
    getItems: function () {
      this.loading = true;
      var _self = this;
      axios
        .get("/api/pager/agencies-central", {
          params: {
            slug: this.agencySlug,
            take: this.take,
            offset: this.offset,
          },
        })
        .then(function (d) {
          _self.loading = false;
          _self.items = _self.items.concat(d.data);
          if (_self.offset == 0) {
            _self.$nextTick(() => {
              _self.scrollAgencyItem();
            });
          }
          _self.offset += _self.take;
        });
    },
    scrollAgencyItem: function () {
      if (document.location.hash) {
        const _self = this;
        setTimeout(() => {
          _self.$scrollTo(document.location.hash, 600, {
            offset: -110,
          });
        }, 600);
      }
    },
  },
  computed: {
    enabled: function () {
      return this.offset < this.total && !this.loading;
    },
  },
  data: function () {
    return {
      items: [],
      loading: false,
    };
  },
};
</script>
